{
  "achievement-center": "Başarı Merkezi",
  "admin": "Yönetici Paneli",
  "admin-learn": "Yönetici Öğren ve Kazan",
  "admin-p2p": "Yönetici P2P",
  "admin-referrals": "Yönetici Referanslar",
  "admin-rewards": "Yönetici Ödülleri",
  "ai-arbitrage-scanner": "AI Arbitraj Tarayıcı",
  "ai-assistant": "AI İşlem Asistanı",
  "ai-copy-trading": "AI Kopya Alım Satım",
  "ai-grid-trading": "AI Grid İşlem",
  "ai-launchpad": "AI Launchpad",
  "ai-market-scanner": "AI Piyasa Tarayıcı",
  "ai-news": "AI Haberler",
  "ai-portfolio": "AI Portföy Yöneticisi",
  "ai-profit-calculator": "AI Kâr Hesaplayıcı",
  "ai-risk-manager": "AI Risk Yöneticisi",
  "ai-smart-alerts": "AI Akıllı Uyarılar",
  "ai-trust-score": "AI Güven Skoru",
  "ai-whale-alerts": "AI Balina Uyarıları",
  "ai-whale-heatmap": "AI Balina Isı Haritası",
  "ai-whale-tracker": "AI Balina Takibi",
  "buy": "Kripto Al",
  "certificates": "Sertifikalarım",
  "dashboard": "Kontrol Paneli",
  "exalt-utility-center": "Exalt Fayda Merkezi",
  "futures": "Vadeli İşlemler",
  "kyc": "KYC Talepleri",
  "kyc-submit": "KYC Gönder",
  "learnearn": "Öğren ve Kazan",
  "listings": "Listeleme Başvurusu",
  "markets": "Piyasalar",
  "notification-center": "Bildirim Merkezi",
  "orders": "Emirler",
  "p2p": "P2P",
  "profile": "Profil",
  "referral": "Referans",
  "reputation-center": "Topluluk İtibarı",
  "rewards": "Ödüller",
  "settings": "Ayarlar",
  "social-trading": "Sosyal Alım Satım",
  "spotTrading": "Spot İşlem",
  "staking": "Staking",
  "support": "Destek",
  "trade": "Spot İşlem",
  "transactions": "İşlemler",
  "wallets": "Cüzdanlar",
  "web3wallet": "Web3 Cüzdan"
}